import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AcdBreadcrumbComponent } from '@app/menu/components/acd-breadcrumb/acd-breadcrumb.component';
import { BackUpComponent } from '@app/menu/components/back-up/back-up.component';
import { BreadcrumbsComponent } from '@app/menu/components/breadcrumbs/breadcrumbs.component';
import { ContextSwitcherComponent } from '@app/menu/components/context-switcher/context-switcher.component';
import { EndUserSubNavComponent } from '@app/menu/components/end-user-sub-nav/end-user-sub-nav.component';
import { EnterpriseSubNavComponent } from '@app/menu/components/enterprise-sub-nav/enterprise-sub-nav.component';
import { MainNavToggleComponent } from '@app/menu/components/main-nav-toggle/main-nav-toggle.component';
import { MenuContainerComponent } from '@app/menu/components/menu-container/menu-container.component';
import { SearchInputComponent } from '@app/menu/components/search-input/search-input.component';
import { SiteBreadcrumbComponent } from '@app/menu/components/site-breadcrumb/site-breadcrumb.component';
import { SubNavItemComponent } from '@app/menu/components/sub-nav-item/sub-nav-item.component';
import { SystemSubNavComponent } from '@app/menu/components/system-sub-nav/system-sub-nav.component';
import { TrunkSwitcherComponent } from '@app/menu/components/trunk-switcher/trunk-switcher.component';
import { SharedModule } from '@app/shared/shared.module';
import { EnterprisesModule } from '@business/enterprises/enterprises.module';
import { RichPresenceModule } from '@business/rich-presence/rich-presence.module';
import { TrunkModule } from '@business/trunk/trunk.module';
import { AcdSubNavComponent } from './components/acd-sub-nav/acd-sub-nav.component';
import { AcdSwitcherComponent } from './components/acd-switcher/acd-switcher.component';
import { CallCenterBreadcrumbComponent } from './components/call-center-breadcrumb/call-center-breadcrumb.component';
import { CallCenterQueueBreadcrumbComponent } from './components/call-center-queue-breadcrumb/call-center-queue-breadcrumb.component';
import { CallCenterQueueSubNavComponent } from './components/call-center-queue-sub-nav/call-center-queue-sub-nav.component';
import { CallCenterQueueSwitcherComponent } from './components/call-center-queue-switcher/call-center-queue-switcher.component';
import { EndUserCallCenterSubNavComponent } from './components/end-user-call-center-sub-nav/end-user-call-center-sub-nav.component';
import { EndUserMainNavComponent } from './components/end-user-main-nav/end-user-main-nav.component';
import { EndUserPhoneBookSubNavComponent } from './components/end-user-phone-book-sub-nav/end-user-phone-book-sub-nav.component';
import { EndUserSwitcherComponent } from './components/end-user-switcher/end-user-switcher.component';
import { EnterpriseAbRoutingSubNavComponent } from './components/enterprise-ab-routing-sub-nav/enterprise-ab-routing-sub-nav.component';
import { EnterpriseCalendarSubNavComponent } from './components/enterprise-calendar-sub-nav/enterprise-calendar-sub-nav.component';
import { EnterpriseCallCenterSubNavComponent } from './components/enterprise-call-center-sub-nav/enterprise-call-center-sub-nav.component';
import { EnterpriseEndUserSubNavComponent } from './components/enterprise-end-user-sub-nav/enterprise-end-user-sub-nav.component';
import { EnterpriseEndUsersSubNavComponent } from './components/enterprise-end-users-sub-nav/enterprise-end-users-sub-nav.component';
import { EnterpriseJournalSubNavComponent } from './components/enterprise-journal-sub-nav/enterprise-journal-sub-nav.component';
import { EnterpriseMainNavComponent } from './components/enterprise-main-nav/enterprise-main-nav.component';
import { EnterprisePhoneBookSubNavComponent } from './components/enterprise-phone-book-sub-nav/enterprise-phone-book-sub-nav.component';
import { EnterpriseSettingsSubNavComponent } from './components/enterprise-settings-sub-nav/enterprise-settings-sub-nav.component';
import { EnterpriseSiteSubNavComponent } from './components/enterprise-site-sub-nav/enterprise-site-sub-nav.component';
import { EnterpriseSwitcherComponent } from './components/enterprise-switcher/enterprise-switcher.component';
import { EnterpriseTrunkSubNavComponent } from './components/enterprise-trunk-sub-nav/enterprise-trunk-sub-nav.component';
import { GenericBreadcrumbComponent } from './components/generic-breadcrumb/generic-breadcrumb.component';
import { MainNavItemComponent } from './components/main-nav-item/main-nav-item.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { MenuContextComponent } from './components/menu-context/menu-context.component';
import { ServiceProviderMainNavComponent } from './components/service-provider-main-nav/service-provider-main-nav.component';
import { SubNavComponent } from './components/sub-nav/sub-nav.component';
import { SystemAdminMainNavComponent } from './components/system-admin-main-nav/system-admin-main-nav.component';
import { MenuItemGroupTitleDirective } from './directives/menu-item-group-title.directive';

@NgModule({
  imports: [SharedModule, RouterModule, EnterprisesModule, TrunkModule, RichPresenceModule],
  declarations: [
    BackUpComponent,
    BreadcrumbsComponent,
    ContextSwitcherComponent,
    EndUserSwitcherComponent,
    GenericBreadcrumbComponent,
    MenuContainerComponent,
    EndUserSubNavComponent,
    EnterpriseSubNavComponent,
    SubNavItemComponent,
    SearchInputComponent,
    MainNavToggleComponent,
    EnterpriseSwitcherComponent,
    AcdSubNavComponent,
    AcdBreadcrumbComponent,
    EnterpriseSiteSubNavComponent,
    CallCenterQueueSubNavComponent,
    CallCenterQueueBreadcrumbComponent,
    MenuItemGroupTitleDirective,
    MenuContextComponent,
    SiteBreadcrumbComponent,
    CallCenterBreadcrumbComponent,
    MainNavComponent,
    MainNavItemComponent,
    EnterpriseMainNavComponent,
    ServiceProviderMainNavComponent,
    AcdSwitcherComponent,
    CallCenterQueueSwitcherComponent,
    EndUserMainNavComponent,
    EnterpriseEndUsersSubNavComponent,
    EnterpriseSettingsSubNavComponent,
    EnterpriseCallCenterSubNavComponent,
    EnterpriseCalendarSubNavComponent,
    SubNavComponent,
    EnterprisePhoneBookSubNavComponent,
    EnterpriseJournalSubNavComponent,
    EndUserCallCenterSubNavComponent,
    EndUserPhoneBookSubNavComponent,
    EnterpriseEndUserSubNavComponent,
    EnterpriseAbRoutingSubNavComponent,
    EnterpriseTrunkSubNavComponent,
    TrunkSwitcherComponent,
    SystemAdminMainNavComponent,
    SystemSubNavComponent,
  ],
  exports: [
    BreadcrumbsComponent,
    MenuContainerComponent,
    SearchInputComponent,
    ContextSwitcherComponent,
    AcdBreadcrumbComponent,
    CallCenterQueueBreadcrumbComponent,
    SiteBreadcrumbComponent,
    CallCenterBreadcrumbComponent,
  ],
})
export class MenuModule {}
